import { SkillGroup } from '../../samwin-skills/skill-group';
import { ChatId } from './chat-id';
import { ChatPeerDetails } from './chat-peer-details';

export class ChatDetails {
   public skill: SkillGroup;
   public peer: ChatPeerDetails;

   public constructor(public id: ChatId, public chatUrl: string, public isHistoricChat, public skillId: number) {
      // nothing to do
   }

   public enrich(skillId: number, skill: SkillGroup, peer: ChatPeerDetails): ChatDetails {
      const enriched = new ChatDetails(this.id, this.chatUrl, this.isHistoricChat, skillId);

      enriched.skill = skill;
      enriched.peer = peer;

      return enriched;
   }
}
